import { render, staticRenderFns } from "./QuickViewHeader.vue?vue&type=template&id=9f6dc728&scoped=true&"
import script from "./QuickViewHeader.vue?vue&type=script&lang=js&"
export * from "./QuickViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuickViewHeader.vue?vue&type=style&index=0&id=9f6dc728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6dc728",
  null
  
)

export default component.exports